export default __webpack_public_path__ + "72039e026e473016b50d2867583ca4d8.png";